import axios from 'axios'

export default {
  saveShoppingCart (shoppingCart) {
    return axios.post(process.env.VUE_APP_BACKEND_BASE_URL + '/shoppingcarts/', {products: shoppingCart}).then((response) => {
      return response
    })
  },
  getShoppingCart () {
    return axios.get(process.env.VUE_APP_BACKEND_BASE_URL + '/shoppingcarts/').then((response) => {
      return response
    })
  }
}
